const TOGGLE_FRAUD_POPUP_VISIBLE = `payoutsList/TOGGLE_FRAUD_POPUP_VISIBLE`;
const INIT_FRAUD_POPUP = `payoutsList/INIT_FRAUD_POPUP`;

// initState
const initialState = {
	isFraudPopupVisible: false,
	payoutsToReject: null
};

// actions
const actions = {
	initFraudPopup: (selectedPayouts) => ({
		type: TOGGLE_FRAUD_POPUP_VISIBLE,
		payload: selectedPayouts
	}),
	toggleFraudPopup: () => ({
		type: TOGGLE_FRAUD_POPUP_VISIBLE
	})
};

// reducers
const reducers = {
	[TOGGLE_FRAUD_POPUP_VISIBLE]: (state, action) => ({
		...state,
		isFraudPopupVisible: !state.isFraudPopupVisible,
		payoutsToReject: action.payload
	}),
	[INIT_FRAUD_POPUP]: (state, action) => ({
		...state,
		isFraudPopupVisible: true,
		payoutsToReject: action.payload
	})
};

// selectors
const selectors = {
	getIsFraudPopupVisible: state => state.payoutsList.isFraudPopupVisible,
	getPayoutsToReject: state => state.payoutsList.payoutsToReject
};

export default {
	initialState,
	actions,
	reducers,
	selectors
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/popups/fraud/index.js